module.exports = __webpack_public_path__ + "img/LY.4318762c.svg";